import { render, staticRenderFns } from "./ErrorAcrticle.vue?vue&type=template&id=6049654b&scoped=true"
import script from "./ErrorAcrticle.vue?vue&type=script&lang=js"
export * from "./ErrorAcrticle.vue?vue&type=script&lang=js"
import style0 from "./ErrorAcrticle.vue?vue&type=style&index=0&id=6049654b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6049654b",
  null
  
)

export default component.exports